var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#1D1D1B;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 2.737, 29.77)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1412",
    className: "st2",
    d: "M405.52,667.84c0,52.96-105.7,95.89-105.7,95.89s-105.7-42.93-105.7-95.89 c0-52.96,105.69-95.9,105.69-95.9S405.52,614.88,405.52,667.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1413",
    className: "st2",
    d: "M194.19,478.15c2.73,51.99,105.63,93.79,105.63,93.79s102.9-41.8,105.63-93.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1414",
    className: "st2",
    d: "M194.19,857.53c2.73-51.99,105.63-93.79,105.63-93.79s102.9,41.8,105.63,93.79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    transform: "translate(10.758 15.343)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_13",
    className: "st2",
    x1: 216.25,
    y1: 509.71,
    x2: 274.97,
    y2: 509.71
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_14",
    className: "st2",
    x1: 303.16,
    y1: 509.71,
    x2: 361.88,
    y2: 509.71
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    transform: "translate(10.758 108.773)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    className: "st2",
    x1: 214.41,
    y1: 701.08,
    x2: 273.13,
    y2: 701.08
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    className: "st2",
    x1: 303.16,
    y1: 701.86,
    x2: 361.88,
    y2: 701.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    transform: "translate(10.758 45.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_17",
    className: "st2",
    x1: 216.25,
    y1: 571.21,
    x2: 274.97,
    y2: 571.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    className: "st2",
    x1: 303.16,
    y1: 571.21,
    x2: 361.88,
    y2: 571.21
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    transform: "translate(10.758 76.754)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_19",
    className: "st2",
    x1: 212.57,
    y1: 634.44,
    x2: 271.29,
    y2: 634.44
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_20",
    className: "st2",
    x1: 306.84,
    y1: 637.57,
    x2: 365.56,
    y2: 637.57
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    transform: "translate(0 61.002)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    className: "st2",
    x1: 194.13,
    y1: 603.61,
    x2: 279.37,
    y2: 603.61
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_22",
    className: "st2",
    x1: 320.28,
    y1: 603.61,
    x2: 405.52,
    y2: 603.61
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    transform: "translate(-441.827 125.909)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    transform: "translate(441.827 -83.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1415",
    d: "M544.91,675.45c-2.99-2.1-4.57-5.68-4.12-9.3c0.26-14.85-0.17-29.72,0.57-44.55 c0.52-11.2,1.83-22.35,3.91-33.37c3.58-18.66,16.81-29.99,32.1-39.32c10.73-6.54,22.31-11.9,32.26-19.44 c11.99-9.08,22.62-19.95,33.9-29.97c2.98-2.82,6.19-5.4,9.6-7.7c7.72-4.85,15.75-6.1,24.11-0.29c1.35-3.09,2.65-5.99,3.89-8.92 c3.91-9.3,7.75-18.61,11.69-27.9c3.83-8.25,12.27-13.35,21.35-12.92c9.2,1.34,15.91,9.39,15.58,18.68 c0.12,7.33-0.68,14.65-2.38,21.78c-4.57,17.96-10.22,35.64-14.92,53.57c-3.9,14.53-11.5,27.8-22.06,38.52 c-16.05,16.76-32.56,33.07-48.95,49.5c-1.86,1.86-3.48,3.34-1.78,6.21c0.37,1.19,0.45,2.45,0.24,3.69 c0,10.86-0.12,21.72,0.07,32.58c0.41,3.65-1.3,7.21-4.41,9.16L544.91,675.45z M553.19,623.93l1.15,0.38 c0.21,0.11,0.45,0.18,0.68,0.22c21.84,0.03,43.69,0.03,65.53,0c1.08-0.03,2.12-0.45,2.93-1.18 c18.92-18.84,37.96-37.56,56.57-56.7c9.43-9.37,16.26-21.03,19.84-33.83c4.95-18.37,10.48-36.61,15.35-55.01 c1.23-5.32,1.85-10.77,1.83-16.23c0.07-2.84-0.67-6.52-4.39-6.93c-3.35-0.16-6.46,1.72-7.87,4.76c-0.4,0.77-0.75,1.57-1.05,2.39 c-7.27,17.33-14.44,34.71-21.88,51.97c-1.52,3.55-3.58,6.84-6.12,9.76c-11.87,13.49-23.98,26.77-36,40.13 c-2.82,3.49-5.89,6.78-9.18,9.84c-1.92,1.4-4.39,1.84-6.68,1.19c-2-1.27-3.38-3.32-3.8-5.66c0.08-1.96,0.93-3.81,2.35-5.17 c14.42-16.23,29.03-32.3,43.39-48.59c2.1-2.42,3.59-5.31,4.35-8.42c1.09-4.7-1.94-7.39-6.52-5.85c-3.02,1.13-5.81,2.8-8.21,4.94 c-4.27,3.62-8.17,7.68-12.25,11.53c-17.37,16.42-35.75,31.31-57.54,41.85c-7.38,4.13-14.05,9.42-19.76,15.67 c-3.54,3.52-6.03,7.97-7.18,12.83C556.26,599.72,554.96,611.87,553.19,623.93z M553.99,662.44h72.57v-24.68h-72.56L553.99,662.44 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1416",
    d: "M346.39,459.69c0.75-2.34,1.35-4.75,2.3-7.02c3.14-8.7,12.73-13.21,21.43-10.07 c0.57,0.21,1.13,0.44,1.67,0.71c5.76,2.27,10.32,6.81,12.63,12.56c4.29,10.75,8.9,21.37,13.39,32.04c0.47,1.11,1,2.2,1.49,3.28 c11.95-5.65,20.74-3.93,31.31,5.86c9.33,8.64,18.78,17.17,28.07,25.86c10.7,9.99,23.45,16.73,36.11,23.77 c7.33,4.21,14.26,9.08,20.7,14.56c10.71,8.87,15.43,20.97,17.45,34.52c3.58,24.07,2.82,48.27,2.94,72.45 c-0.07,3.03-1.76,5.8-4.44,7.23h-90.66c-2.85-2.05-4.37-5.48-3.96-8.97c0.23-7.98,0.06-15.96,0.07-23.94 c-0.38-4.09-0.27-8.22,0.32-12.29c0.75-2.58-0.24-5.36-2.47-6.87c-15.63-15.58-31.33-31.08-46.69-46.92 c-12.55-12.78-21.34-28.76-25.41-46.21c-4.8-20.17-10.79-40.06-16.26-60.07L346.39,459.69z M523.15,624.59 c-1.24-10.33-2.44-20.09-3.56-29.83c-1.03-9.94-6.08-19.03-13.98-25.16c-5.49-4.27-11.22-8.23-17.15-11.87 c-10.2-6.44-21.26-11.75-30.71-19.12c-12.16-9.49-23.11-20.54-34.56-30.93c-3.42-3.11-6.72-6.45-11.65-6.96 c-3.52-0.36-5.13,1.13-5.29,4.65c0.11,4.04,1.89,7.85,4.91,10.52c14.37,15.95,28.71,31.93,43.02,47.93 c1.03,1.07,1.8,2.36,2.24,3.77c0.92,2.88-0.51,5.99-3.3,7.18c-3.49,1.7-6.18,0.2-8.56-2.47c-14.73-16.46-29.56-32.84-44.2-49.36 c-2.19-2.55-3.98-5.42-5.31-8.5c-3.87-8.63-7.42-17.41-11.09-26.12c-3.96-9.41-7.88-18.84-11.89-28.23 c-1.37-3.22-5.6-6.11-8.17-5.5c-3.46,0.83-4.18,3.87-4.26,6.72c-0.33,4.08-0.08,8.19,0.74,12.2 c4.55,17.2,10.02,34.17,14.18,51.46c3.38,15.81,11.09,30.36,22.26,42.04c18.64,18.94,37.53,37.64,56.41,56.35 c1.17,0.85,2.61,1.27,4.05,1.18c15.23,0.08,30.46,0.05,45.69,0.05L523.15,624.59z M522.93,662.45c0-7.14-0.15-14.1,0.07-21.04 c0.1-3.16-0.94-3.97-4.02-3.95c-21.07,0.12-42.15,0.06-63.23,0.08c-1.94,0-3.89,0.17-5.71,0.26v24.66H522.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    transform: "translate(471.549 -125.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1418",
    d: "M499.31,568.84c-1.49-0.43-2.94-0.99-4.33-1.67c-2.3-1.34-2.49-2.78-0.95-4.9 c0.57-0.77,1.12-1.55,1.79-2.48l-2.53-1.18c0-3.79,2.56-7.11,6.23-8.06c3.04-0.73,6.21-0.86,9.3-1.39 c0.91-0.2,1.76-0.59,2.51-1.15c3.52-2.76,7.2-5.3,11.02-7.63c2.72-1.2,4.44-3.92,4.37-6.89c0.06-2.75-0.44-5.49-1.48-8.04 c-3.32-7.52-7.15-14.81-10.56-22.29c-0.59-1.84-0.89-3.77-0.9-5.71c-0.61-5.96-0.59-5.96-6.24-4.66 c-9.61,2.05-19.64,0.67-28.35-3.89c-7.77-3.89-14.9-8.96-21.12-15.02c-1.75,1.77-3.44,3.56-5.22,5.23 c-0.53,0.58-1.28,0.92-2.06,0.94c-4.25-0.81-8.44-1.86-12.56-3.16c-2.02-1.06-3.88-2.4-5.52-3.99 c-3.73,3.37-5.78,8.22-5.59,13.25c0.04,3.88,0.55,7.75,0.86,11.94c0.2,0.08,0.73,0.29,1.26,0.51c2.64,1.13,4.62,2.68,4.43,5.98 c-0.16,2.68,0.15,5.4-0.22,8.04c-0.4,2.94-2.49,3.73-4.59,1.66c-1.56-1.67-2.83-3.6-3.75-5.7c-0.99-2.07-1.44-4.4-2.3-6.54 c-0.42-1.04-1.07-1.97-1.91-2.71c-2.88-1.95-3.85-5.75-2.26-8.85c1.33-3.69,2.2-7.55,3.16-11.37c0.76-3.01,1.35-6.06,2.05-9.21 c-2.07-0.36-4.19,0.25-5.76,1.65c-3.42,2.98-5.67,7.07-6.34,11.56c-0.81,3.48-1.04,7.1-1.54,10.65c-0.24,1.05,0.35,2.1,1.37,2.45 c0.95,0.51,1.7,1.33,2.12,2.32c0.61,1.76,1.06,3.58,1.35,5.43c0.59,3.25-0.6,6.56-3.12,8.7c-2.3,2.22-4.1,1.9-5.29-1.06 c-0.51-1.17-0.83-2.4-0.95-3.67c-0.53-5.41-1.59-10.76-3.16-15.97c-1.18-3.92-0.46-8.17,1.93-11.5c2.95-4.36,4.91-9.31,5.74-14.5 c0.79-4.18,2.57-6.31,6.6-6.78c2.82-0.36,5.67-0.31,8.47,0.15c6.4,1.2,12.95,1.32,19.38,0.34c0-2.53-0.14-5.05,0.03-7.56 c0.48-5,1.88-9.87,4.14-14.37c2.24-4.82,4.59-9.59,6.6-14.49c2.14-5.26,2.39-11.09,0.7-16.51c-0.53-2.41-2.14-4.45-4.36-5.53 c-2.55,2.26-4.85,4.39-7.25,6.4c-2.11,2.33-5.16,3.6-8.3,3.44c-0.36,1.11-0.77,2.2-1.25,3.26c-1.28,2.86-4.41,4.42-7.46,3.7 c-3.1-0.54-5.49-3.04-5.9-6.16c-0.3-3.08,0.44-6.18,2.11-8.78c1.39-2.19,2.6-4.49,3.64-6.87c1.65-3.93,2.87-8.04,4.61-11.92 c1.23-2.3,2.58-4.53,4.05-6.68c0.4-0.68,0.64-1.45,0.67-2.24c0.07-3.51,0.03-7.02,0.03-11.17l3.99,3.4 c-0.16-1.3-0.23-2.62-0.22-3.93c0.13-1.81,1.23-2.36,2.51-1.1c2.15,2.18,4.18,4.48,6.08,6.89c0.53,0.88,1.58,1.32,2.58,1.08 c11.59-2.23,23.57,0.84,32.66,8.37c0.46,0.38,0.91,0.77,1.35,1.18c0.09,0.08,0.07,0.29,0.11,0.44h-5.2l-0.25,0.48 c0.91,0.8,1.77,1.66,2.73,2.38c5.66,3.83,10.64,8.59,14.73,14.06c1.38,2.01,2.51,4.19,4.1,6.86l-6.77-2.49l-0.39,0.42 c0.61,1.04,1.17,2.12,1.85,3.11c4.52,6.2,7.39,13.46,8.32,21.07c0.22,2.61,0.22,5.23,0,7.84c-0.21,1.02,0.29,2.06,1.22,2.54 c3.79,2.32,8.1,3.63,12.54,3.81c7.72,0.21,15.38,1.38,22.8,3.48c6.98,1.94,13.24,5.85,18.04,11.28c0.33,0.4,0.75,0.73,1.21,0.96 c11.98,5.69,20.9,14.92,28.97,25.1c2.28,2.87,4.04,6.16,6.45,8.9c2.13,2.49,4.62,4.65,7.39,6.41c7.93,4.39,16.52,7.48,25.44,9.13 c1.05,0.17,2.05,0.56,2.94,1.15c-3.22,0.99-6.39,2.16-9.67,2.92c-8.36,2.18-17.05,2.78-25.63,1.77 c-10.25-0.72-18.46-8.79-19.35-19.03c-0.79-5.1-1.15-10.26-1.84-15.38c-0.22-1.63-0.68-3.21-1.37-4.7 c-1.23-2.47-4.13-3.61-6.7-2.62c-0.52,0.32-0.86,0.87-0.91,1.48c0.16,15.46-7.82,26.32-19.85,34.73 c-2.29,1.54-3.79,4.01-4.09,6.76c-0.66,5.38,0.2,10.84,2.46,15.77c2.22,4.76,0.16,10.41-4.59,12.63 c-1.19,0.56-2.49,0.86-3.81,0.89c-0.74,0.02-1.47,0.19-2.14,0.51c-6.81,3.27-12.48,8.5-16.29,15.01 c-0.45,0.82-1.23,1.41-2.13,1.64c-4.94,0.46-9.11,3.86-10.54,8.61c-0.11,0.27-0.17,0.55-0.26,0.83L499.31,568.84z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    transform: "translate(-142.147 302.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1419",
    d: "M880.54,240.64c-17.06,26.26-39.11,48.92-64.89,66.68c-29.42,20.74-63.47,33.96-99.18,38.5 c-40.14,5.18-80.94-0.24-118.34-15.73c-44.83-18.16-81.43-47.22-111.58-84.72c-4.03-4.57-4.11-11.4-0.18-16.06 c34.44-41.66,75.17-74.74,127.33-91.64c49.29-15.97,98.1-13.29,146.11,5.73c37,14.66,68.78,37.31,97.4,64.63 c6.44,6.15,12.58,12.63,18.7,19.09c1.71,2.06,3.26,4.25,4.65,6.54L880.54,240.64z M852.03,238.56c-8.12-7.69-15-14.7-22.42-21.1 c-8.3-7.16-16.83-14.09-25.69-20.52c-31.73-23.01-66.63-38.56-105.88-42.97c-26.64-2.96-53.61,0.06-78.93,8.84 c-31.49,11.09-60.22,28.85-84.22,52.06c-7.57,7.1-14.66,14.72-21.91,22.05c36.93,43.79,91.07,77.14,150.76,83.81 c22.97,2.69,46.24,1.4,68.78-3.82c33.85-7.86,65.04-24.47,90.46-48.16C833.06,259.43,842.09,248.95,852.03,238.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1420",
    d: "M682.1,171.85c36.15,0.23,65.4,29.46,65.65,65.6c-0.17,36.15-29.37,65.44-65.51,65.75 c-36.28-0.17-65.66-29.53-65.84-65.81C616.72,201.27,645.97,172.08,682.1,171.85z M665.4,237.71 c13.78,0.32,25.22-10.58,25.54-24.36c0-0.19,0.01-0.38,0.01-0.57c0.17-13.98-11-25.46-24.98-25.66 c-14.11,0-25.58,11.37-25.7,25.48c0.1,13.84,11.3,25.03,25.14,25.12L665.4,237.71z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1df2b2952ad43b7da59c113552f3eeff.svg";
export { ForwardRef as ReactComponent };